import { useSetRecoilState } from "recoil";
import { useEffectOnce } from "../../hooks/useCustomEffects";
import { getJobStatusList } from "../../services/jobsService";
import { jobsStatusState } from "../../storage/jobStates";

export function JobStatusProvider() {
  const setJobStatusList = useSetRecoilState(jobsStatusState);

  useEffectOnce(() => {
    const loadJobStatus = async () => {
      const { jobStatusList, error } = await getJobStatusList();
      if (!error && jobStatusList) {
        setJobStatusList(jobStatusList);
      } else {
        setJobStatusList(undefined);
      }
    };
    loadJobStatus();
  });

  return null;
}
